import NewApiService from "@/utils/new.api.service";

export default {
    list(ctx, params) {
        const {pagination, search, filters, expand} = params

        var filter = [];
        if(filters) {
            Object.keys(filters).forEach((key) => {
                filter[key] = filters[key]
            });
        }

        let sort = pagination?pagination.sortBy[0]:null;

        if(pagination && pagination.sortDesc[0] == false){
            sort = '-'+sort;
        }
        let page = pagination?pagination.page:1
        let rows_per_page = pagination?pagination.itemsPerPage:0

        return new Promise((resolve, reject) => {
            NewApiService.get("warehouse-locations",{
                sort, page, search, filter, expand, rows_per_page
              })
            .then(({data}) => {
                resolve(data)
            })
            .catch(({ response }) => {
                reject(response)
            });
        });
    },
    create(ctx, model) {
        return new Promise((resolve, reject) => {
            NewApiService.post("warehouse-locations",model)
            .then(({data}) => {
                resolve(data)
            })
            .catch(({ response }) => {
                reject(response)
            });
        });
    },
    
    update(ctx, model) {
        return new Promise((resolve, reject) => {
            NewApiService.put("warehouse-locations/"+model.id,model)
            .then(({data}) => {
                resolve(data)
            })
            .catch(({ response }) => {
                reject(response)
            });
        });
    },
    
    delete(ctx, model) {
        return new Promise((resolve, reject) => {
            NewApiService.delete("warehouse-locations/"+model.id)
            .then(({data}) => {
                resolve(data)
            })
            .catch(({ response }) => {
                reject(response)
            });
        });
    }
    
}